// src/hooks/useTranslation.ts

import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "stores/useLanguage";
import { translationService } from "api/services/translationService";
import type { TranslationMap } from "types/translation.types";

export const useTranslation = (keys: number[]) => {
  const { currentCode } = useLanguage();

  const sortedKeys = [...keys].sort((a, b) => a - b);

  const { data: translations, isLoading, isSuccess } = useQuery<TranslationMap>({
    queryKey: ["translations", currentCode, sortedKeys.join(",")],
    queryFn: () => translationService.getByKeys(currentCode, sortedKeys),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    enabled: keys.length > 0,
  });

  const t = (key: number, fallback?: string): string =>
    translations?.[key] ?? fallback ?? String(key);

  return { t, isLoading, isSuccess };
};
